import React, { Component } from "react";
import {
  Container,
  Button,
  ModalFooter,
  ModalBody
} from "reactstrap";


export default class LoginError extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10 }}>{this.props.loginErrorMessage}</h5>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="success"
              onClick={() => {
                this.props.goBack();
              }}
            >
              Ok
            </Button>{" "}
            
          </div>
        </ModalFooter>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginError/LoginError.js